import { MapfreCardComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { DisclaimersComponent } from '../../../../common/disclaimers/disclaimers.component';
import { LoyaltyBannerComponent } from '../../../../../loyalty-banner/loyalty-banner.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { PolicyDataService } from './../../../../../_services/data-services/policy-data.service';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { BillingNewService } from '@services/common/billing-new.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { filter } from 'rxjs/operators';
import { Constants } from '@models/constants';
import { ClientCredentialsService } from '@services/client-credentials/client-credentials.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, DisclaimersComponent, LoyaltyBannerComponent],
  selector: 'app-billing-main-container',
  templateUrl: './billing-main-container.component.html',
  styleUrls: ['./billing-main-container.component.scss']
})
export class BillingMainContainerComponent implements OnInit {

  showBillingMessage: boolean;
  isOneIncPayment: any;
  isAcmic: boolean;
  isNextAmountDueDisclaimer = false
  showLoyaltyBanner = false;
  policies: any;
  currPolicy: any;
  currUrl: string;
  checkingSavingMakeAPayment = false;

  constructor(
    private policyDataService: PolicyDataService,
    private router: Router,
    private billingNewService: BillingNewService,
    private acmicService: AcmicService,
    private clientCredentialsService: ClientCredentialsService,
  ) { }

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    let allPoliciesList;
    this.policyDataService.$policyDetails.subscribe((policyResponse: any) => {
      if (policyResponse) {
        this.showNextAmountDueDisclaimer(policyResponse)
        setTimeout(() => {
          policyResponse.forEach((policy)=>{
            this.showBillingMessage = this.showBillingMessage || !policy.hasAffinityGroup;
          })
        },0);
      }
    }
    );
    this.billingNewService.getOneIncPaymentStatus().subscribe((val) => {
      setTimeout(() => {
        this.isOneIncPayment = val;
      }, 0);
    })
    this.clientCredentialsService.getToken().subscribe((token) => {
      const user = JSON.parse(localStorage.getItem('currentUser'));
      user.access_token = token;
      localStorage.setItem('currentUser', JSON.stringify(user));
      this.policyDataService.$policyDetails.subscribe((policyList) => {
        if (policyList && policyList.length) {
          this.policies = policyList;
          allPoliciesList = policyList;
          if (!this.isAcmic) {
            this.showLoyaltyBannerOnRouteChange(this.router, allPoliciesList);
          }
        }
      });
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          if (!this.isAcmic) {
            this.showLoyaltyBannerOnRouteChange(event, allPoliciesList);
          }
        })
    });

    this.billingNewService.checkingOrSavingsSelected$.subscribe((val) => {
      setTimeout(() => {
        this.checkingSavingMakeAPayment = val;
      }, 0);
    })
  }

  private showNextAmountDueDisclaimer(policies: any[]) {
    this.extractPolicyDetails(this.router.url, policies);

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.extractPolicyDetails(event.urlAfterRedirects || event.url, policies);
    });
  }

  private extractPolicyDetails(url: string, policies: any[]): void {
    this.currUrl = url;
    let policyNumber = null;
    if (url.includes('/details') || url.includes('/make-a-payment')) {
      const match = url.match(/billing-new\/([^/]+)\/details/) || url.match(/billing-new\/([^/]+)\/make-a-payment/);
      policyNumber = match ? match[1] : null;
    }

    if (policyNumber && Array.isArray(policies)) {
      this.currPolicy = policies.find(
        (policy) => policy?.policynumber?.policyNumber === policyNumber
      );
      this.isNextAmountDueDisclaimer = this.currPolicy?.scheduleBills?.
            find((e) => e.invoiceState == 'Planned')
    }
  }

  isDisclaimer(): boolean {
    const url = this.router.url
    return url.includes('billing-landing') || url.includes('documents') 
            || (url.includes('make-a-payment') && !this.checkingSavingMakeAPayment);
  }
  isPolicyEligibleForLoyaltyBanner(policy) {
    if (policy) {
      return (
        (policy.policyType === 'AUTO' && policy.policySubType !== 'MAIP') ||
        (policy.policyType === 'HOME' && policy.policySubType !== 'FAIR') ||
        (policy.policynumber.policyNumber.length === 6 &&
          policy.policyType === 'AUTO')
      );
    }
    return false;
  }

  private isAtleastOnePolicyElgblForLoyaltyBanner(policyList: any[]) {
    let isLoyaltyBannerVisible = false;
    policyList?.forEach((policy) => {
      if (!isLoyaltyBannerVisible) {
        isLoyaltyBannerVisible = this.isPolicyEligibleForLoyaltyBanner(policy);
      }
    });
    return isLoyaltyBannerVisible;
  }

  showLoyaltyBannerOnRouteChange(eventOrRoute, allPoliciesList) {
    // if (/^\/billing-new\/[^/]+\/documents$/.test(eventOrRoute.url)) {
    //   this.showLoyaltyBanner = false;
    //   return;
    // }

    if (
      eventOrRoute?.url === Constants.MY_INSURANCE ||
      eventOrRoute?.url === '/billing-new' ||
      eventOrRoute?.url === '/billing-new/billing-landing'
    ) {
      this.showLoyaltyBanner =
        this.isAtleastOnePolicyElgblForLoyaltyBanner(allPoliciesList);
    } else if (
      (eventOrRoute?.url?.startsWith(Constants.MY_INSURANCE) &&
        (eventOrRoute?.url?.endsWith('/details') ||
          eventOrRoute?.url?.endsWith('/coverages'))) ||
      eventOrRoute?.url?.startsWith('/billing-new/')
    ) {
      const policyIdFromUrl = eventOrRoute?.url?.split('/')[2];
      const policyObj = allPoliciesList.find(
        (policy) => policyIdFromUrl === policy.policynumber.policyNumber
      );
      this.showLoyaltyBanner = this.isPolicyEligibleForLoyaltyBanner(policyObj);
    } else {
      this.showLoyaltyBanner = false;
    }
  }
}